import Config from '../../config'
import { GetCall, PostCallMultiForm } from '../helper'


const URLS = {
    "JOB_LIST": Config.BASE_API_URL + "/v3/job",
    "JOB_DETAILS":Config.BASE_API_URL + "/v3/job/",
    "APPLY_JOB":Config.BASE_API_URL + "/v3/job/apply",
    "SEARCH_JOB":Config.BASE_API_URL + "/v3/job"
}

export const GetJobList = async (page?:any,params?:any) => {
    return await GetCall(URLS.JOB_LIST, {'application': 'website','page':page ? page : 1, ...params} , Config.DEFAULT_HEADER);
}

export const GetJobDetails = async (id:number) => {
    return await GetCall(`${URLS.JOB_DETAILS}${id}`, {'application': 'website'} , Config.DEFAULT_HEADER);
}

export const ApplyJob = async(data?:any) => {
    return await PostCallMultiForm(URLS.APPLY_JOB, data);
}

export const SearchJob = async(data?:any) => {
    return await GetCall(URLS.SEARCH_JOB, { ...data ,"application": 'website'},Config.DEFAULT_HEADER);
}
